import { render } from "./Admin.vue?vue&type=template&id=eb3fb40a&ts=true"
import script from "./Admin.vue?vue&type=script&setup=true&lang=ts"
export * from "./Admin.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Layouts/Admin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eb3fb40a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eb3fb40a', __exports__)) {
    console.log('reload')
    api.reload('eb3fb40a', __exports__)
  }
  
  module.hot.accept("./Admin.vue?vue&type=template&id=eb3fb40a&ts=true", () => {
    console.log('re-render')
    api.rerender('eb3fb40a', render)
  })

}


export default __exports__